import { ColorOptions, ModBox, Text } from '@jfs/ui-new'

const FiuStatusData = ({
  isApproved,
  title,
  subTitleKey,
  subSubTitleKey,
  subTitleValue,
  subSubTitleValue,
  show,
  applicationId,
}: any) => {
  return (
    <ModBox marginTop={32} w={400} show={show}>
      <ModBox marginLeft={36} borderBottomWidth={1} borderBottomStyle={'dashed'} borderBottomColor={'BLACK_75'}>
        <Text
          title={title}
          color={isApproved ? ('BLACK_21' as ColorOptions) : 'BLACK_21'}
          fontSize={16}
          fontFamily={'jiotype-bold'}
          textAlign={'left'}
        />
        <ModBox marginTop={16} marginBottom={24}>
          <ModBox direction={'row'}>
            <Text title={subTitleKey} color={'BLACK_75'} fontSize={12} fontFamily={'jiotype-medium'} />
            <Text
              title={subTitleValue?.length > 0 ? subTitleValue : 'NA'}
              color={'BLACK_21'}
              fontSize={12}
              fontFamily={'jiotype-bold'}
            />
          </ModBox>
          <ModBox show={!isApproved && applicationId?.length > 0} direction={'row'}>
            <Text title={'Application Id: '} color={'BLACK_75'} fontSize={12} fontFamily={'jiotype-medium'} />
            <Text title={applicationId} color={'BLACK_21'} fontSize={12} fontFamily={'jiotype-bold'} />
          </ModBox>
          <ModBox direction={'row'} marginBottom={24}>
            <Text
              title={subSubTitleKey?.length > 0 ? subSubTitleKey : ''}
              color={'BLACK_75'}
              fontSize={12}
              fontFamily={'jiotype-medium'}
            />
            <Text
              title={subSubTitleValue?.length > 0 ? subSubTitleValue : ''}
              color={'BLACK_21'}
              fontSize={12}
              fontFamily={'jiotype-bold'}
            />
          </ModBox>
        </ModBox>
      </ModBox>
    </ModBox>
  )
}

export { FiuStatusData }
